import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { CategoryForm } from '@/components/forms/CategoryForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CategoryCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/category-management/categories')
  }

  const handleCancel = () => {
    navigate('/category-management/categories')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex={1}>
          <Card h="full" display="flex" flexDirection="column">
            <CardHeader flexShrink={0}>
              <Heading size="md">Create Category</Heading>
              <Text fontSize="sm" color={colors.text} mt={1}>
                Add a new category to the catalog
              </Text>
            </CardHeader>
            <CardBody overflowY="auto" flex={1} minH={0}>
              <CategoryForm onSuccess={handleSuccess} onCancel={handleCancel} />
            </CardBody>
          </Card>
        </Box>
      </Box>
    </AdminLayout>
  )
}
